import {useRef, useState} from "react";

import {LeasePackageCatalogDetailDto} from "../../model/LeasePackageCatalog";
import {customAxios} from "../customAxios";

export function useGetLeasePackageCatalog() {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<LeasePackageCatalogDetailDto>();
    const [error, setError] = useState<Error>();
    const latestRequest = useRef(0);

    async function execute(id: number) {
        const request = ++latestRequest.current;
        try {
            setLoading(true);
            setError(undefined);
            const catalog = await getLeasePackageCatalog(id);
            if(request === latestRequest.current) setData(catalog);
            return catalog;
        } catch (e) {
            if(request === latestRequest.current) setError(e as Error);
            return Promise.reject(e);
        } finally {
            if(request === latestRequest.current) setLoading(false);
        }
    }

    return {loading, data, error, execute};
}

export async function getLeasePackageCatalog(id: number): Promise<LeasePackageCatalogDetailDto> {
    const response = await customAxios.get<LeasePackageCatalogDetailDto>(`/v1/lease-package-catalogs/${id}`);
    return response.data;
}
